import {useEffect,useState,useLayoutEffect} from 'react'
import {Box,Typography,Button,Grid,IconButton,CircularProgress, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox, Divider} from '@mui/material'
import Header from '../Components/Header'
import {useTheme,styled } from '@mui/material/styles'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import {useNavigate} from 'react-router-dom'
import Snackbar from '@mui/material/Snackbar'
import Link from '@mui/material/Link';
import { Alarm, ArrowBack, EmailOutlined, LinkRounded} from '@mui/icons-material';
import MultiInput from '../Components/MultiInput';
import UserInput from '../Components/UserInput';
import start_application from '../Redux/reducers/start_application';
import { FileUploader } from 'react-drag-drop-files';
import send_application from '../Redux/reducers/send_application';
import axios from 'axios';


const ContainerBox = styled(Box, {
	})(({ theme}) => ({
		transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowY: 'auto',
	overflowX: 'hidden',
	'&::-webkit-scrollbar': {
		width: 10,
		backgroundColor: '#000000'
	},
	'&::-webkit-scrollbar-thumb': {
		backgroundColor: '#ffffff',
		borderRadius: 10
	},
	minHeight:250,
	justifyContent:"flex-start",
	alignItems:"center",
	borderRadius:10,
	maxHeight:500
	})
);

const JobTest = ()=>{

	const [open,setOpen] = useState(false)
	const [message,setMessage] = useState('')
	const navigate = useNavigate()
	const theme = useTheme()
	const dispatch = useDispatch()
	const [email,setEmail] = useState('')
	const user = useSelector(state => state?.auth.user);
	const [response,setResponse] = useState("")
	const [responses,setResponses] = useState([])
	const [hasStarted,setHasStarted] = useState(false)
	const [submitting,setSubmitting] = useState(false)
	const data = useSelector(state => state?.job.job);
	const [recentQuestion,setRecentQuestion] = useState(data?.questions[0])
	const [uploading, setUploading] = useState(false)
	const [deleting, setDeleting] = useState(false)
	const [hasEnded, setHasEnded] = useState(false)
	const [index, setIndex] = useState(0)
	const [file, setFile] = useState(null)
	const [showModal,setShowModal] = useState(false)
	const [isLogoUploaded, setIsLogoUploaded] = useState(false);
	const [isDocUploaded, setIsDocUploaded] = useState(false);
	const [logoUrl, setLogoUrl] = useState(null);
	const [docUrl, setDocUrl] = useState(null);
	const fileTypes = ["JPG","JPEG", "PNG", "GIF"] 
	const docTypes = ["PDF","DOC", "DOCX"] 

async function handleSend (){
	try{
		if (hasStarted) {
			if (recentQuestion?.type !== "Files" && recentQuestion?.type !== "Image") {
				
				const send_data = {
					id:data?.id,
					email:email,
					index:index,
					type:recentQuestion?.type,
					question:recentQuestion?.content,
					response:recentQuestion?.type === "Multiple" ? responses : response
				}
			
				await send_application(dispatch,send_data,setOpen,setMessage,setResponse,setResponses,setHasStarted,setHasEnded,setRecentQuestion,setIndex,setSubmitting)
			
			} else {
				if (isLogoUploaded || isDocUploaded) {
					
					const send_data = {
						id:data?.id,
						email:email,
						index:index,
						type:recentQuestion?.type,
						question:recentQuestion?.content,
						response:isLogoUploaded ? logoUrl : docUrl
					}
				
					await send_application(dispatch,send_data,setOpen,setMessage,setResponse,setResponses,setHasStarted,setHasEnded,setRecentQuestion,setIndex,setSubmitting)
				} else {
					setMessage("please, upload the file before to continue")
					setOpen(true)
				}
			}
		} else{
			if (email !== "") {

				const send_data = {
					id:data?.id,
					email:email
				}

				await start_application(dispatch,send_data,setOpen,setMessage,setRecentQuestion,setHasStarted,setHasEnded,setIndex,setSubmitting)
			
			} else {
				setMessage("Please, write down your email to start the application")
				setOpen(true)
			}
		}
	}catch(err){
		console.log(err)
	}
}

async function handleUploadFile(data,isLog){
try {

	setUploading(true)

	let formData = new FormData()

	formData.append("file",data)

	const upload = await axios.post(`${process.env.REACT_APP_SOCKET_URL}api/data/usr/file/upload/`,formData).catch(err=>{
		setMessage("Error while uploading")
		setOpen(true)
		setUploading(false)
		console.log(err)
	})

	if (upload?.status == 200 && upload?.data?.success) {
		if (isLog) {
			setLogoUrl(upload?.data?.url)
			setIsLogoUploaded(true)
			// setFile(null)
		} else {
			setDocUrl(upload?.data?.url)
			setIsDocUploaded(true)
			// setFiles(null)
		}
		setMessage("file uploaded on the server")
		setOpen(true)
		setUploading(false)
		// setUploaded(true)
	} else {
		setMessage(upload?.data?.message)
		setOpen(true)
		setUploading(false)
	}
	
} catch (error) {
	console.log(error)
	setUploading(false)
}
}

async function handleDeleteFile(url,isLog){
try {

	setDeleting(true)

	const data ={
		url:url
	}

	const upload = await axios.post(`${process.env.REACT_APP_SERVER_URL}/delete-file`,data).catch(err=>{
		setMessage("Error while deleting")
		setOpen(true)
		setDeleting(false)
		console.log(err)
	})

	if (upload?.status == 200 && upload?.data?.success) {
		if (isLog) {
			setLogoUrl(null)
			setIsLogoUploaded(false)
			setFile(null)
		} else {
			setDocUrl(null)
			setIsDocUploaded(false)
			setFile(null)
		}
		setMessage(upload?.data?.message)
		setOpen(true)
		setDeleting(false)
		// setUploaded(false)
	} else {
		setMessage(upload?.data?.message)
		setOpen(true)
		setDeleting(false)
	}
	
} catch (error) {
	console.log(error)
	setDeleting(false)
}
}

	return(
	 <Grid container>
		<Grid item xs={12} sm={12} md={12} style={{height:40}}>
		</Grid>
		<Grid item xs={12} sm={12} md={12} style={{width:"100%",justifyContent:"center",alignItems:"center"}}>
        <Box m={2} sx={{background:"#100101",minWidth:500,maxWidth:"70%",marginLeft:{sm:5,xs:5,md:17}}} display="flex" flexDirection="row" justifyContent="center" alignItems="flex-start">
            <Box mt={2} width="90%">
                <Header>
                    <Breadcrumbs aria-label="breadcrumb">
						<Typography sx={{fontSize:12,color:"gray"}}>Dashboard</Typography>
                        <Typography sx={{fontSize:12,color:"gray"}}>Job View</Typography>
                    </Breadcrumbs>			
                </Header>
                <Snackbar 
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }} 
                    message={message} 
                    onClose={()=>{setOpen(false)}}
                    open={open} 
                    autoHideDuration={2000}
                />
                <ContainerBox sx={{p:2,width:"90%"}}>
					<Box width="100%">
						<Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="100%">
							<Typography  mb={2} mt={2} ml={4} variant="h6" color="gold" fontWeight={500} sx={{fontFamily:"dinofans"}}>
								Job View Application
							</Typography>	
							<IconButton onClick={(e)=>{
								e?.preventDefault()
								navigate("/jobs")
							}}>
								<ArrowBack fontSize='small' sx={{color:"gold"}}/>
							</IconButton>					
						</Box>
						<Box mb={2} ml={4}>
							<Typography color="gold" style={{fontFamily:"dinofans",marginBottom:5}}>
								Job Info
							</Typography>
							<Box display="flex" flexDirection="row" justifyContent="space-between" m={1} alignItems="center" width="80%">
								<Box>
									<Typography color="gray" style={{fontFamily:"dinofans"}}>
										Title
									</Typography>
									<Typography sx={{color:'white',marginBottom:1,fontSize:12}}>
										{data?.title} at {data?.enterprise_name}
									</Typography>
								</Box>
								<Box >
									<Typography color="gold" style={{fontFamily:"dinofans"}}>
										Deadline
									</Typography>
									<Typography color="gold" fontSize={14} width={80}>
										{data?.deadline}
									</Typography>
								</Box>
							</Box>
							<Box ml={1}>
								<Typography color="gray" style={{fontFamily:"dinofans"}}>
									Description
								</Typography>
								<Typography sx={{color:'white',fontSize:12,marginBottom:1}}>
									{data?.description}
								</Typography>
								<Typography color="gray" style={{fontFamily:"dinofans"}}>
									Type
								</Typography>
								<Typography sx={{color:'white',fontSize:12,marginBottom:1}}>
									{data?.type}
								</Typography>
								<Typography color="gray" style={{fontFamily:"dinofans"}}>
									Location
								</Typography>
								<Typography sx={{color:'white',fontSize:12,marginBottom:1}}>
									{data?.category}
								</Typography>
							</Box>
							<Box> 
							{
								hasStarted && (
									<Box mt={2} mb={2}>
										<Divider sx={{mb:2}}/>
										<Typography sx={{color:'white',fontSize:15,marginBottom:1,ml:2}}>
											{recentQuestion?.content}
										</Typography>
									</Box>
								)
							}
							{
								(recentQuestion?.type === "Simple" && hasStarted) && (
									<Box mt={2} mb={2} ml={2}>
                                        <MultiInput input={response} setInput={setResponse} label="answer"/>
                                    </Box>
								)
							}
							{
								(recentQuestion?.type === "One" && hasStarted) && (
									<Box justifyContent="center" alignItems="center" width="100%" m={1}>
										<FormControl>
											<RadioGroup
													aria-labelledby="demo-row-radio-buttons-group-label"
													name="row-radio-buttons-group"
												>
													{
														recentQuestion?.choices?.map((item,index)=>(
															<FormControlLabel key={index} value={item} control={<Radio onClick={()=>{
																setResponse(item)
															}} />} label={item} />
														))
													}
												</RadioGroup>                        
										</FormControl>
                                    </Box> 
								)
							}
							{
								(recentQuestion?.type === "Multiple" && hasStarted) && (
									<Box justifyContent="center" alignItems="center" width="100%" mt={2}>
										<FormControl>
											<FormLabel sx={{fontFamily:"dinofans",fontSize:12,color:"gold"}} id="demo-row-radio-buttons-group-label">Choose :</FormLabel>
												{
													recentQuestion?.choices?.map((item,index)=>(
														<FormControlLabel key={index} control={<Checkbox value={item} onClick={(e)=>{
															e?.preventDefault()
															setResponses(prev=>[...prev,item])
														}} />} label={item} />
													))
												}                   
										</FormControl>
                                    </Box> 
								)
							}
							{
								(recentQuestion?.type === "Image" && hasStarted) && (
									<>
										<Box pl={2} mt={2} justifyContent="center" alignItems="center" width="40%">
											<FileUploader onDrop={(file)=>{setFile(file)}} maxSize={5} multiple={false} handleChange={(file)=>{
												setFile(file)
											}} name="file" types={fileTypes} />
										</Box>
										{file !== null && (
											<Box ml={2} mt={1} justifyContent="flex-start" alignItems="center" display="flex" flexDirection="row">
												<Button disabled={uploading || isLogoUploaded} onClick={(e)=>{
													e?.preventDefault()
													handleUploadFile(file,false)
												}}  sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:10,mr:1}} variant="contained">
													Upload
												</Button>
												{
													isLogoUploaded && (
														<Button disabled={deleting} onClick={(e)=>{
															e?.preventDefault()
															handleDeleteFile(logoUrl,false)
														}}  sx={{background:"maroon",color:"#fff",fontFamily:"dinofans",fontSize:10}} variant="contained">
															Delete
														</Button>
													)
												}
											</Box>
										)}
									</>
								)
							}
							{
								(recentQuestion?.type === "Files" && hasStarted) && (
									<Box m={1}>
										<Box pl={2} mt={2} justifyContent="center" alignItems="center" width="40%">
											<FileUploader onDrop={(file)=>{setFile(file)}} maxSize={5} multiple={false} handleChange={(file)=>{
												setFile(file)
											}} name="file" types={docTypes} />
										</Box>
										{file !== null && (
											<Box ml={2} mt={1} justifyContent="flex-start" alignItems="center" display="flex" flexDirection="row">
												<Button disabled={uploading || isDocUploaded} onClick={(e)=>{
													e?.preventDefault()
													handleUploadFile(file,false)
												}}  sx={{background:"#fff",color:"#000",fontFamily:"dinofans",fontSize:10,mr:1}} variant="contained">
													Upload
												</Button>
												{
													isDocUploaded && (
														<Button disabled={deleting} onClick={(e)=>{
															e?.preventDefault()
															handleDeleteFile(docUrl,false)
														}}  sx={{background:"maroon",color:"#fff",fontFamily:"dinofans",fontSize:10}} variant="contained">
															Delete
														</Button>
													)
												}
											</Box>
										)}
									</Box>
								)
							}
							{
								(recentQuestion?.type === "Link" && hasStarted) && (
									<Box mt={2} mb={2}>
                                        <UserInput input={response} setInput={setResponse} label="link">
											<LinkRounded/>
										</UserInput>
                                    </Box>
								)
							}
							{
								!hasStarted && (
									<Box mt={2} mb={2}>
                                        {
											hasEnded ?
											<Box mt={2} mb={2}>
												<Typography  m={1} variant="h6" color="gold" fontWeight={500} sx={{fontFamily:"dinofans"}}>
													Congratulation !
												</Typography>
												<Typography sx={{color:'white',fontSize:12,marginBottom:1,ml:2}}>
													You have successfully submitted your application !
												</Typography>
											</Box>
											:

											<UserInput input={email} setInput={setEmail} label="Confirm your email">
												<EmailOutlined/>
											</UserInput>
										}
									</Box>
								)
							}
							{
								hasEnded ?
									<Button onClick={async (e)=>{
											e?.preventDefault()
											navigate("/jobs")
										}} disabled={submitting ? true : false} sx={{backgroundColor:"gold",color:"black",marginLeft:1,marginRight:{xs:0,md:5},fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
										Close
									</Button>
								:
									<Button onClick={async (e)=>{
										e?.preventDefault()
										await handleSend()
									}} disabled={submitting ? true : false} sx={{backgroundColor:"gold",color:"black",marginLeft:1,marginRight:{xs:0,md:5},fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
									{
										submitting ?  <CircularProgress size={20} sx={{color:"black"}}/>  :  (!submitting && hasStarted) ? "Next" : "Start"
									}
									</Button>
							}
						</Box>
						</Box>
					</Box>
                </ContainerBox>
            </Box>
        </Box>
		</Grid>
		<Grid item xs={12} sm={12} md={12} style={{height:40}}>
		</Grid>
	 </Grid>
	)}

	export default JobTest